import Vue from 'vue';

export const eventHub = new Vue();

export const EventHubVuexPlugin = store => {
  store.$eventHub = eventHub;
};
